export const generateCookieParams = (env, currentNetwork) => {
  // Fix PS-12854 - In some case, currentNetwork is partially load so we need to split the destructuring.
  const {
    payment_gateway: paymentMethod = null,
    has_payment_account: hasPaymentAccount = false,
    linked_in_is_enabled: linkedInIsEnabled = false,
    twitter_is_enabled: twitterIsEnabled = false,
    facebook_is_enabled: facebookIsEnabled = false,
    has_google_analytics_tracking: hasGoogleAnalyticsTracking = false,
  } = currentNetwork.network_configuration || {};

  const {
    amplitude: { config: { amplitude_enabled: amplitudeIsEnabled } = {} } = {},
    cookies: { config: { cookies: customCookies } = {} } = {},
  } = currentNetwork.features || {};

  return {
    env,
    paymentMethod,
    hasPaymentAccount,
    amplitudeIsEnabled,
    linkedInIsEnabled,
    customCookies,
    twitterIsEnabled,
    facebookIsEnabled,
    hasGoogleAnalyticsTracking,
  };
};
